import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AdminPageHeaderComponent } from '../../../shared/admin';
import { SettingsReminderCronSectionComponent } from './settings-reminder-cron-section.component';

@Component({
  selector: 'app-settings-page',
  standalone: true,
  imports: [RouterLink, AdminPageHeaderComponent, SettingsReminderCronSectionComponent],
  templateUrl: './settings-page.component.html',
  styleUrl: './settings-page.component.scss',
})
export class SettingsPageComponent {}
